"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var getFetchHeaders = function (requestHeader) {
    return requestHeader.reduce(function (result, current) {
        var _a;
        var headerContent = current.getHeader();
        return headerContent
            ? __assign(__assign({}, result), (_a = {}, _a[current.name] = headerContent, _a)) : result;
    }, {});
};
exports.default = getFetchHeaders;
